import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontSizeInPx, FontWeight, LineHeightInPx, Spacing } from "@snapchat/snap-design-system";

export const breadcrumbContainer = css`
    padding-bottom: ${Spacing.XS}px;
`;

export const BreadcrumbItem = styled.span<{ active?: boolean }>`
    font-size: ${FontSizeInPx.COMPACT}px;
    font-weight: ${({ active }) => (active ? FontWeight.BOLD : FontWeight.MEDIUM)};
    line-height: ${LineHeightInPx.REGULAR}px;
    color: ${Colors.Black.V50};
`;
